import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { API_URL, STATUS_LABEL, fmtDT } from './lmShared';

export const LmHistoryDialog = ({ leadId, onClose }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!leadId) return;
    setData(null);
    axios.get(`${API_URL}/lead-mgmt/leads/${leadId}/history`).then((r) => setData(r.data)).catch(() => setData({ items: [], lead: {} }));
  }, [leadId]);

  return (
    <Dialog open={!!leadId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" aria-describedby={undefined} data-testid="lm-history-dialog">
        <DialogHeader><DialogTitle>Histórico · {data?.lead?.client_name || '…'}</DialogTitle></DialogHeader>
        {data && (
          <div className="space-y-3">
            <p className="text-xs text-slate-500">
              Criada {fmtDT(data.lead.created_at)} por {data.lead.created_by_name || (data.lead.imported_batch ? 'Importação' : '—')} · Estado atual: <b>{STATUS_LABEL[data.lead.status] || data.lead.status}</b> · Com: <b>{data.lead.assigned_to_name || 'ninguém'}</b>
            </p>
            <div className="max-h-[60vh] overflow-y-auto space-y-2 pr-1">
              {data.items.length === 0 && <p className="text-sm text-slate-400">Sem contactos registados.</p>}
              {data.items.map((c) => (
                <div key={c.id} className={`text-xs border-l-2 pl-3 py-1 ${c.system ? 'border-violet-400 bg-violet-50/50' : 'border-slate-300'}`} data-testid={`lm-history-item-${c.id}`}>
                  <p className="text-slate-400">{fmtDT(c.created_at)} · {c.created_by_name || '—'}{c.outcome && !c.system ? ` · ${c.outcome}` : ''}</p>
                  <p className="text-slate-700 whitespace-pre-wrap">{c.notes || '—'}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
